<template>
  <div id="modal" class="modal payment_select_modal" v-show="modalShown">
    <div class="modal-main wrapper">
      <section class="payment_select">
        <h2>決済方法選択</h2>
        <div>
          <div class="radio">
            <input type="radio" id="const_payment_defer" name="payment_sel" :value="3" v-model.number="paymentType2"/>
            <label :for="'const_payment_defer'" class="radio-label bold">掛け払い</label>
          </div>
          <div class="radio">
            <input type="radio" id="const_payment_bank" name="payment_sel" :value="2" v-model.number="paymentType2"/>
            <label :for="'const_payment_bank'" class="radio-label bold">銀行振込</label>
          </div>
          <div class="radio">
            <input type="radio" id="const_payment_card" name="payment_sel" :value="1" v-model.number="paymentType2"/>
            <label :for="'const_payment_card'" class="radio-label bold">クレジットカード決済</label>
          </div>
        </div>
        <!-- <div class="input_error_field">
          <div v-if="errors.paymentType" class="error_text">{{errors.paymentType}}</div>
        </div> -->
      </section>
      <div class="control_btn_area">
        <div class="detail_btn2" @click="success()">決定</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PaymentSelectModal',
  components: {
  },
  props: {
    paymentType: {
      type: Number,
      default: 0
    },
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      error: {},
      paymentType2: 0
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    success: function () {
      this.callbackParams = {
        paymentType: this.paymentType2
      }
      this.onOk(this.callbackParams)
      this.modalShown = false
    }
  },
  created () {
    this.paymentType2 = this.paymentType
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/order/DcPaymentSelectModal.vue